import React, { useEffect, useState } from "react";
import SortRoundedIcon from "@mui/icons-material/SortRounded";
import CardMultimedia from "../components/clientes/CardMultimedia";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import useProduct from "../hooks/useProduct";
import useMultimedia from "../hooks/useSectionClients";
import CardDownloadMultimedia from "../components/clientes/CardDownloadMultimedia";
import { useNavigate } from "react-router-dom";

function Clientes() {
  const [categoria, setCategorias] = useState(true);
  const { products } = useProduct();
  const { multimedias, loading } = useMultimedia();
  const [multi, setMulti] = useState();

  const [busqueda, setBusqueda] = useState("");
  const [multiInstitucional, setMultiInstitucional] = useState(false);

  const navigate = useNavigate();

  function actCategoria() {
    setCategorias(!categoria);
  }
  
  let catSelect;

  const handleChangeSelect = (event) => {
    const selected = event.target.value;
    setBusqueda(selected);
  };

  const handleChangeCat = (event) => {
    catSelect = event.target.outerText;
    if (catSelect === "Institucional") {
      setMultiInstitucional(true)
      setMulti(multimedias[0]?.others);
    } else {
      setMultiInstitucional(false)
      setMulti(multimedias[0]?.products);
    }
  };

  useEffect(() => {
    if (catSelect !== "Institucional") {
      setMulti(
        multimedias[0]?.products.filter((m) => m?.name === busqueda && m)
      );
    }
    if (busqueda === "Todos") {
      setMulti(multimedias[0]?.products);
    }
  }, [busqueda, catSelect, multimedias]);

  useEffect(() => {
    if(multimedias?.length > 0){
      setMulti(multimedias[0]?.products);
    }
  }, [multimedias]);

  const logueado = JSON.parse(localStorage.getItem("Usuario"));
  useEffect(() => {
    document.title = "Sección Clientes Tensolite";

    if (!logueado) {
      navigate("/clientes/login");
    }
  }, [logueado, navigate]);

  return (
      <div className="container-main-section-clientes">
        <div className="container-sub-menu-clientes">
          <button
            className={
              categoria ? "sub-menu-clientes" : "sub-menu-clientes-false"
            }
            onClick={actCategoria}
          >
            <SortRoundedIcon />
          </button>
          {categoria ? (
            <div className="menu-clientes-list">
              <ul onClick={(e) => handleChangeCat(e)}>
                <li value="Productos">
                  <span>Productos</span>{!multiInstitucional ? <ArrowDownwardIcon /> : <ArrowForwardRoundedIcon />}
                </li>
                <li value="Institucional">
                  <span>Institucional</span>
                  {multiInstitucional ? <ArrowDownwardIcon /> : <ArrowForwardRoundedIcon />}
                </li>
              </ul>
            </div>
          ) : null}
        </div>
        <div className="container-main-contenido-clientes">
          <div className="container-welcome-user">
            <h2>Bienvenido:</h2>
            <h3>{`${logueado?.UserLogin?.name}`}</h3>
          </div>
          <div className="card-downloads">
            <div className="select-none mt-2 mb-3">
              <p className="mt-2 me-2 font-filter">Filtrar por: </p>
              <select
                className="products-select"
                defaultValue="Todos"
                name="products-select"
                onChange={(e) => handleChangeSelect(e)}
              >
                <option value="Todos">Todos</option>
                {products?.map(
                  (product, index) =>
                    product?.deleted !== true &&
                    product?.visible === true &&
                    product?.filename.length > 0 && (
                      <option key={index} value={product.title}>
                        {product.title}
                      </option>
                    )
                )}
              </select>
            </div>
          </div>
          <div className="tag-clientes">
            <h3>Multimedia</h3>
          </div>
          <div className="container-card-clientes-media">
            {multi?.length > 0 ? (
              multi?.map((mult) => <CardMultimedia multimedia={mult} />)
            ) : (
              <h3>No se encontraron resultados</h3>
            )}
          </div>
          <div className="tag-clientes">
            <h3>Ficha tecnica</h3>
          </div>
          <div className="container-card-clientes-media">
            {multi?.length > 0 ? (
              multi?.map((mult) => <CardDownloadMultimedia multimedia={mult} />)
            ) : (
              <h3>No se encontraron resultados</h3>
            )}
          </div>
        </div>
      </div>
    )
}

export default Clientes;
